import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp } from "../lib/motion";

export const CTASection = ({
  eyebrow = "Ready when you are",
  title = "Let's build something your business is proud of.",
  subtitle = "Like what you've seen? Take out a quote below with just a few questions about your business. Still unsure? Book a free discovery call and we can help you figure out the best next steps.",
  primary = { label: "Get a quote", to: "/pricing" },
  secondary = { label: "Book a call", to: "/contact" },
}) => {
  return (
    <section className="section" data-testid="final-cta-section">
      <div className="container-page">
        <motion.div
          {...fadeUp}
          className="relative overflow-hidden rounded-[28px] bg-slate-950 text-white px-8 py-20 md:py-28 md:px-16"
        >
          <div className="absolute inset-0 grid-lines-bg opacity-40" aria-hidden="true" />
          <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-blue-600/30 blur-3xl" aria-hidden="true" />
          <div className="relative max-w-3xl">
            <p className="eyebrow text-blue-400">{eyebrow}</p>
            <h2 className="mt-4 text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.05]">
              {title}
            </h2>
            <p className="mt-6 text-lg text-slate-300 leading-relaxed max-w-xl">{subtitle}</p>
            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <Link to={primary.to} className="btn-primary" data-testid="cta-primary-button">
                {primary.label}
                <ArrowUpRight className="h-4 w-4" />
              </Link>
              <Link
                to={secondary.to}
                className="inline-flex items-center justify-center gap-2 bg-white/5 border border-white/15 text-white rounded-full px-7 py-3.5 text-sm font-semibold hover:bg-white/10 transition-colors"
                data-testid="cta-secondary-button"
              >
                {secondary.label}
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
